export const SIDEBARSHOW = '@sidebarshow';
